import { render } from "./AnotherPage.vue?vue&type=template&id=ddf05d98&scoped=true"
import script from "./AnotherPage.vue?vue&type=script&lang=js"
export * from "./AnotherPage.vue?vue&type=script&lang=js"

import "./AnotherPage.vue?vue&type=style&index=0&id=ddf05d98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf05d98"]])

export default __exports__